/* BD 24.09.2026 v1. Alt: financing opens callback; thumbnail inline JS. Neu: financing prepares existing contact[body], gallery returns to device image. Grund: single product inquiry path, no submission/event duplication or B2 changes. */
(function () {
  'use strict';
  if (window.bdMachineFirstBound) return;
  window.bdMachineFirstBound = true;
  document.addEventListener('click', function (event) {
    var finance = event.target.closest('[data-bd-machine-finance]');
    if (finance) {
      var form = document.getElementById('bd21-machine-lead-form');
      var field = form && form.querySelector('[name="contact[body]"]');
      // Native anchor remains usable even if a custom form embed supplies no body field.
      if (!field) return;
      var line = 'Konditionen für ' + finance.dataset.bdMachineFinanceProduct + ': ' + finance.dataset.bdMachineFinance;
      var prior = field.dataset.bdFinancePrefill || '';
      if (prior && field.value.indexOf(prior) === 0) {
        field.value = line + field.value.slice(prior.length);
      } else if (field.value.indexOf(line) !== 0) {
        field.value = line + (field.value.trim() ? '\n\n' + field.value : '');
      }
      field.dataset.bdFinancePrefill = line;
      // No synthetic input/change: opening financing is a CTA, not customer typing or a lead.
      var details = finance.closest('details');
      if (details) details.open = false;
      return;
    }
    var thumb = event.target.closest('[data-bd-machine-image]');
    if (!thumb) return;
    var hero = document.querySelector('[data-bd-machine-hero]');
    var image = hero && hero.querySelector('.bd21-product-image img');
    if (!image) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = thumb.dataset.bdMachineImage;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hero.scrollIntoView({block:'start',behavior:reduced?'auto':'smooth'});
  });
})();
